<div class="row g-4 ">

  <!-- Desktop view -->
  <div class="col-12 col-md-4" *ngFor="let item of data.details.services">
    <div class="course-card">
      <div class="card-img">
        <div class="price">{{ item.price }}</div>
        <img [src]="item.imageIconPath" [alt]="item.imageAlt" />
      </div>
      <div class="card-content">
        <h1>{{ item.titleTr }}</h1>
        <p class="mb-4">{{ item.summary }}</p>
        <a class="btn" [href]="getDetailsUrl(item)" *ngIf="data.details.isDetails">{{ item.btnText }}</a>
      </div>
    </div>
  </div>




</div>